export {default} from './ListingDetail';



// WEBPACK FOOTER //
// ./src/pages/ListingDetail/index.ts